import {Fragment} from "preact";
import {useContent} from "./useContent.js";
import s from "./content.module.css";
import {iconSearchRed, logo} from "../../../assets";

const Content = () => {
    // Component logic data
    const componentProps = useContent();

    // Destructured component logic data
    const {
        filterQuery,
        availableLocations,
        handleChange,
        handleLocationChange
    } = componentProps;

    return (
        <Fragment>
            <div className={s.root}>
                <div>
                    <div className={"flex flex-row justify-start items-center gap-x-3"}>
                        <img
                            src={logo}
                            alt="Sabin logo"
                            className={s.sabinLogo}
                        />
                        <h1 className={s.headingTitle}>
                            |&nbsp;&nbsp;&nbsp;Loja virtual
                        </h1>
                    </div>
                    <h5 className={s.paragraph}>
                        Escolha a cidade para personalizar o atendimento:
                    </h5>
                </div>
                <div>
                    <div className={"relative mb-5"}>
                        <input
                            type="text"
                            placeholder={"Qual sua cidade?"}
                            id={"location-modal-input"}
                            name={"location-modal-input"}
                            value={filterQuery}
                            onInput={e => handleChange(e)}
                            className={s.input}
                        />
                        <button
                            type={"button"}
                            className={s.searchButton}
                        >
                            <img
                                src={iconSearchRed}
                                alt="Search icon"
                            />
                        </button>
                    </div>
                    <ul className={s.list}>
                        {availableLocations.map(location => {
                            return (
                                <li key={location.id}>
                                    <button
                                        type={"button"}
                                        className={s.regionButton}
                                        data-testid={`${location.code}-button`}
                                        onClick={() => handleLocationChange({
                                            id: location.id,
                                            name: location.name,
                                            code: location.code,
                                        })}
                                    >
                                        {location.name}
                                    </button>
                                </li>
                            )
                        })}
                        {availableLocations.length === 0 && (
                            <li className={s.noPlacesFound}>
                                Nenhum local encontrado!
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </Fragment>
    )
}

export default Content;
